import { memoize } from 'underscore';
import * as FieldTypes from 'ContentUtils/constants/CustomWidgetFieldTypes';
import Raven from 'raven-js';
import ColorPickerField from './pickers/ColorPicker';
import FontPicker from './pickers/FontPicker';
import { makeAsyncComponent } from '../utils/makeAsyncUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncChoiceField = makeAsyncComponent(() => import( /* webpackChunkName: 'ChoiceField' */'ContentComponents/components/cmv2/fields/Choice'));
const AsyncNumberField = makeAsyncComponent(() => import( /* webpackChunkName: 'NumberField' */'ContentComponents/components/cmv2/fields/Number'));
const AsyncBooleanField = makeAsyncComponent(() => import( /* webpackChunkName: 'BooleanField' */'ContentComponents/components/cmv2/fields/Boolean'));
const AsyncFieldGroup = makeAsyncComponent(() => import( /* webpackChunkName: 'FieldGroup' */'ContentComponents/components/cmv2/fields/FieldGroup'));
const AsyncImageField = makeAsyncComponent(() => import( /* webpackChunkName: 'ImageField' */'ContentComponents/components/cmv2/fields/Image'));
const AsyncGradientField = makeAsyncComponent(() => import( /* webpackChunkName: 'GradientField' */'ContentComponents/components/cmv2/fields/Gradient'));
const AsyncSpacingField = makeAsyncComponent(() => import( /* webpackChunkName: 'SpacingField' */'ContentComponents/components/cmv2/fields/Spacing'));
const AsyncBackgroundImageField = makeAsyncComponent(() => import( /* webpackChunkName: 'BackgroundImageField' */'ContentComponents/components/cmv2/fields/BackgroundImage'));
const AsyncAlignmentField = makeAsyncComponent(() => import( /* webpackChunkName: 'AlignmentField' */'ContentComponents/components/cmv2/fields/Alignment'));
const AsyncTextAlignmentField = makeAsyncComponent(() => import( /* webpackChunkName: 'TextAlignmentField' */'ContentComponents/components/cmv2/fields/TextAlignment'));
const AsyncBorderField = makeAsyncComponent(() => import( /* webpackChunkName: 'BorderField' */'ContentComponents/components/cmv2/fields/Border'));
const ThemeSettingsFieldsMap = {
  [FieldTypes.CHOICE]: AsyncChoiceField,
  [FieldTypes.NUMBER]: AsyncNumberField,
  [FieldTypes.BOOLEAN]: AsyncBooleanField,
  [FieldTypes.COLOR]: ColorPickerField,
  [FieldTypes.FONT]: FontPicker,
  [FieldTypes.GROUP]: AsyncFieldGroup,
  [FieldTypes.IMAGE]: AsyncImageField,
  // Style fields
  [FieldTypes.GRADIENT]: AsyncGradientField,
  [FieldTypes.SPACING]: AsyncSpacingField,
  [FieldTypes.BACKGROUND_IMAGE]: AsyncBackgroundImageField,
  [FieldTypes.ALIGNMENT]: AsyncAlignmentField,
  [FieldTypes.TEXT_ALIGNMENT]: AsyncTextAlignmentField,
  [FieldTypes.BORDER]: AsyncBorderField
};
const captureUnsupportedFieldMessage = memoize(props => {
  const {
    type: fieldType,
    fieldKey
  } = props;
  Raven.captureMessage('Unsupported theme field type detected', {
    extra: {
      fieldType,
      fieldKey: fieldKey.join('.')
    }
  });
}, props => {
  const {
    type: fieldType,
    fieldKey
  } = props;
  return `${fieldType}:${fieldKey.join('.')}`;
});
const unsupportedFieldHandler = props => {
  captureUnsupportedFieldMessage(props);
  return /*#__PURE__*/_jsx("div", {});
};
export default Object.keys(FieldTypes).reduce((finalMap, key) => {
  const fieldType = FieldTypes[key];
  finalMap[fieldType] = ThemeSettingsFieldsMap[fieldType] || unsupportedFieldHandler;
  return finalMap;
}, {});